// extracted by mini-css-extract-plugin
module.exports = {"root":"TopBar_root__2W-ms","placeholder":"TopBar_placeholder__6dsue","popupContainer":"TopBar_popupContainer__2FNnB"};